/*
 *  Module for displaying a selectable tree hierarchy
 */
define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "modules/shared/treeList/treeListView",
], function (Marionette, Backbone, Messenger, TreeListView) {
  var TreeListController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "treeList";
      this.region = options.region;
      this.namespace = options.namespace;
      this._setUpVents();
    },
    show: function (options) {
      this.view = new TreeListView.treeListRoot({
        collection: options.model,
        namespace: this.namespace,
      });
      this.showRegion(this.view);
    },
    getChecked: function (nodeId) {
      return this.view.getChecked(nodeId);
    },
    setChecked: function (nodeId, isChecked) {
      this.view.setChecked(nodeId, isChecked);
    },
    _setUpVents: function () {
      var namespace;
      if (this.namespace) {
        namespace = this.namespace + ":";
      } else {
        namespace = "";
      }
      Messenger.vent.on(
        namespace + "treeList:select:all",
        function () {
          this.view.selectAll();
        },
        this,
      );

      Messenger.vent.on(
        namespace + "treeList:deselect:all",
        function () {
          this.view.deselectAll();
        },
        this,
      );

      Messenger.reqres.setHandler(
        namespace + "treeList:selected:nodes",
        function () {
          return this.view.getSelectedNodes();
        },
        this,
      );
    },
  });

  return TreeListController;
});
